import React, { FunctionComponent, createContext, useCallback } from "react";
import { useLocalStorageState } from "../../../../hooks/use-local-storage-state";
import { LOCAL_STORAGE_KEY } from "../../../../models/local-storage-keys";
import { Explanation } from "../../../../models/types/category-types";

interface IExplanationContextProviderProps {}

interface IExplanationContext {
  dismissedExplanations: Explanation[];
  setExplanationAsDismissed: (item: Explanation) => void;
  isExplanationDismissed: (item: Explanation) => boolean;
}

export const ExplanationContext = createContext<IExplanationContext>({
  dismissedExplanations: [],
  setExplanationAsDismissed: () => {},
  isExplanationDismissed: (item) => false,
});

export const ExplanationContextProvider: FunctionComponent<IExplanationContextProviderProps> = (props) => {
  const { children } = props;
  const [dismissedExplanations, setDismissedExplanations] = useLocalStorageState<Explanation[]>(
    LOCAL_STORAGE_KEY.DISMISSED_EXPLANATIONS,
    [],
  );

  const setExplanationAsDismissed = useCallback(
    (explanation: Explanation) => {
      setDismissedExplanations([...dismissedExplanations, explanation]);
    },
    [dismissedExplanations, setDismissedExplanations],
  );

  const isExplanationDismissed = useCallback(
    (explanation: Explanation) => dismissedExplanations.includes(explanation),
    [dismissedExplanations],
  );

  return (
    <ExplanationContext.Provider
      value={{
        dismissedExplanations,
        setExplanationAsDismissed,
        isExplanationDismissed,
      }}
    >
      {children}
    </ExplanationContext.Provider>
  );
};
